import React, { useMemo } from "react";
import styled from "styled-components";

const LEVELS = [
  { min: 0, max: 33.33, label: "Foodie", color: "#2563eb" },
  { min: 33.34, max: 66.66, label: "Master", color: "#d97706" },
  { min: 66.67, max: 100, label: "Guru", color: "#be123c" },
];

const toNumber = (value, fallback = 0) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : fallback;
};

const toPercent = (value) => {
  const numeric = Math.max(0, Math.min(100, toNumber(value)));
  return `${numeric.toFixed(1)}%`;
};

const findLevelByProgress = (overallProgress) => {
  const value = Math.max(0, Math.min(100, toNumber(overallProgress)));
  return LEVELS.find((level) => value >= level.min && value <= level.max) || LEVELS[0];
};

const buildTopTopics = (topicsProgress = []) => {
  return [...topicsProgress]
    .sort((a, b) => toNumber(b?.progress_percentage) - toNumber(a?.progress_percentage))
    .slice(0, 3);
};

const HostLevelCard = ({ summary, loading, error }) => {
  const overallProgress = toNumber(summary?.overallProgress);
  const level = findLevelByProgress(overallProgress);
  const attemptedTopics = toNumber(summary?.attemptedTopics);
  const totalTopics = toNumber(summary?.totalTopics);
  const averageAccuracy =
    summary?.averageAccuracy === null || summary?.averageAccuracy === undefined
      ? null
      : toNumber(summary.averageAccuracy);
  const topTopics = useMemo(() => buildTopTopics(summary?.topics || []), [summary?.topics]);

  if (loading) {
    return <Card>Cargando nivel del host...</Card>;
  }

  if (error) {
    return <Card>No fue posible cargar la categoria del host.</Card>;
  }

  if (!summary) {
    return null;
  }

  return (
    <Card>
      {/* <Header>
        <div>
          <Label>Categoria host</Label>
          <LevelTitle $color={level.color}>{level.label}</LevelTitle>
        </div>
        <Score>{toPercent(overallProgress)}</Score>
      </Header>

      <ProgressTrack>
        <ProgressFill $width={Math.max(0, Math.min(100, overallProgress))} $color={level.color} />
      </ProgressTrack> */}

      <StatsRow>
        <StatItem>
          <StatValue>{attemptedTopics}</StatValue>
          <StatLabel>Topicos jugados</StatLabel>
        </StatItem>
        <StatItem>
          <StatValue>{totalTopics}</StatValue>
          <StatLabel>Topicos totales</StatLabel>
        </StatItem>
        <StatItem>
          <StatValue>{averageAccuracy === null ? "--" : toPercent(averageAccuracy)}</StatValue>
          <StatLabel>Precision media</StatLabel>
        </StatItem>
      </StatsRow>

      {topTopics.length > 0 && (
        <TopTopics>
          <TopTitle>Mejores topicos</TopTitle>
          {topTopics.map((topic) => (
            <TopicRow key={topic.topic_id || topic.topic_name}>
              <span>{topic.topic_name || "Topico"}</span>
              <strong>{toPercent(topic.progress_percentage)}</strong>
            </TopicRow>
          ))}
        </TopTopics>
      )}
    </Card>
  );
};

export default HostLevelCard;

const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  padding: 18px;
  margin-bottom: 16px;
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

const Label = styled.p`
  margin: 0;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
`;

const LevelTitle = styled.h3`
  margin: 4px 0 0;
  font-size: 22px;
  line-height: 1.1;
  color: ${({ $color }) => $color || "#0f172a"};
`;

const Score = styled.p`
  margin: 0;
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
`;

const ProgressTrack = styled.div`
  margin-top: 12px;
  width: 100%;
  height: 10px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
`;

const ProgressFill = styled.div`
  height: 100%;
  border-radius: 999px;
  transition: width 0.3s ease;
  width: ${({ $width }) => `${$width || 0}%`};
  background: ${({ $color }) => $color || "#0f172a"};
`;

const StatsRow = styled.div`
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
`;

const StatItem = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px;
`;

const StatValue = styled.p`
  margin: 0;
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
`;

const StatLabel = styled.p`
  margin: 2px 0 0;
  color: #64748b;
  font-size: 11px;
`;

const TopTopics = styled.div`
  margin-top: 14px;
  display: grid;
  gap: 8px;
`;

const TopTitle = styled.p`
  margin: 0;
  font-size: 13px;
  color: #334155;
  font-weight: 600;
`;

const TopicRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  color: #334155;

  strong {
    color: #0f172a;
  }
`;
